var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mall"}},[_c('keep-alive',{attrs:{"exclude":"MallDetail"}},[_c('router-view')],1),_c('main-tab-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }